var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909599",
    d: "M12 7.834c-4.225 0-6.248 3.286-6.714 4.166.466.88 2.489 4.166 6.714 4.166 4.225 0 6.248-3.286 6.713-4.166-.465-.88-2.488-4.166-6.713-4.166zm-7.765 3.951c.006-.013 2.219-4.993 7.765-4.993 5.546 0 7.76 4.977 7.765 4.993a.514.514 0 010 .432c-.006.014-2.219 4.991-7.765 4.991-5.546 0-7.76-4.977-7.765-4.99a.515.515 0 010-.433zM12 15.125c-.862 0-1.643-.349-2.208-.916H9.79A3.116 3.116 0 018.873 12c0-.864.35-1.645.917-2.21A3.12 3.12 0 0112 8.875c.864 0 1.646.35 2.21.917l.03.033a3.116 3.116 0 01-.03 4.383l-.002.002a3.117 3.117 0 01-2.208.917zm-1.473-1.65a2.092 2.092 0 002.948.003c.377-.378.609-.898.609-1.475 0-.564-.223-1.076-.587-1.45l-.024-.025a2.077 2.077 0 00-2.946 0 2.075 2.075 0 000 2.944v.003z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeActiveIcon);
export default __webpack_public_path__ + "static/media/eye-active-icon.4d2eb9c5.svg";
export { ForwardRef as ReactComponent };